module.exports = __webpack_public_path__ + "img/logo.b92c904d.png";